import { type Uuid } from "#customTypes/globalTypes"
import { type Address, type DatabaseObject } from "#customTypes/types"

export interface PersonConstructor extends DatabaseObject {
  id: Uuid
  firstName: string
  lastName: string
  name?: string
  dob: string
  gender: string
  primaryAddress: Address
  personalPhone: string
  personalEmail: string
  notes?: string
  tags?: string[]
  allergies?: string[]
}

export class Person {
  id: Uuid
  name: string
  firstName: string
  lastName: string
  dob: string
  gender: string
  personalPhone: string
  personalEmail: string
  primaryAddress: Address
  notes?: string
  tags?: string[]
  allergies?: string[]

  constructor(props: PersonConstructor) {
    this.id = props.id
    this.firstName = props.firstName
    this.lastName = props.lastName
    this.name = props.name ?? this.getName()
    this.dob = props.dob
    this.gender = props.gender
    this.personalPhone = props.personalPhone
    this.personalEmail = props.personalEmail
    this.primaryAddress = props.primaryAddress
    this.notes = props.notes
    this.tags = props.tags
    this.allergies = props.allergies
  }

  getName = (): string =>
    this.name || `${this.firstName} ${this.lastName}`.trim()

  getFormattedAddress = (): string => Person.formatAddress(this.primaryAddress)

  getTagsAsText = (): string => this.tags?.join(", ") ?? ""

  getAllergiesAsText = (): string => this.allergies?.join(", ") ?? ""

  static formatAddress = (data?: Address): string => {
    if (data == null) return ""

    const { street1, street2, city, state, zipCode } = data

    const street = [street1?.trim(), street2?.trim()].filter(Boolean).join(" ")
    const stateAndZip = [state?.trim(), zipCode?.trim()]
      .filter(Boolean)
      .join(" ")

    const fields = [street, city, stateAndZip].filter(Boolean)
    return fields.join(", ")
  }
}
